
export const ShopData = [
    {
      id: 1,
      title: 'adidas',
      description: 'Carton Astronault Tshirts',
      image: 'http://res.cloudinary.com/dabfyhdoz/image/upload/v1524685644/skirt_fcjpdn.png',
      price: 40,
    },
    {
      id: 2,
      title: 'adidas',
      description: 'Carton Astronault Tshirts',
      image: 'http://res.cloudinary.com/dabfyhdoz/image/upload/v1524685644/shirt_leggf9.png',
      price: 58,
    },
    {
      id: 3,
      title: 'adidas',
      description: 'Carton Astronault Tshirts',
      image: 'http://res.cloudinary.com/dabfyhdoz/image/upload/v1524685644/pink_su4eyp.png',
      price: 178,
    },
    {
      id: 4,
      title: 'adidas',
      description: 'Carton Astronault Tshirts',
      image: 'http://res.cloudinary.com/dabfyhdoz/image/upload/v1524685644/pants_tjrbx0.png',
      price: 278,
    },
  ];
  export default ShopData;


  